/* global Geocomplete, Forms */

import { InitMainAddressCheckboxes } from 'lib/location_form'

window['units#edit'] = window['units#new'] = function () {
  function manageTemplateStrategy (duration = 'normal') {
    const templateStrategy = $('.unit_personal_number_strategy input[type="radio"]:checked').attr('id') === 'unit_personal_number_strategy_template'
    const templateFields = $('#template_strategy_fields')
    if (templateStrategy) templateFields.slideDown(duration)
    else templateFields.slideUp(duration)
  }

  manageTemplateStrategy(0) // on document ready
  $('.unit_personal_number_strategy input').on('change', manageTemplateStrategy) // on radio click

  document.querySelectorAll('.edit-unit-form > .tab-content > .active.show').forEach(element => element.classList.remove('active', 'show'))
  const substring = window.location.hash.substring(1)
  const anchor = '#' + (substring.length > 0 ? substring : 'basic')
  let pane = document.querySelector('.edit-unit-form > .tab-content > ' + anchor)
  let triggerElement = document.querySelector('a[data-bs-target="' + anchor + '"]')
  // Handle nested sub-tabs (e.g. #other-settings inside #datev-settings)
  if (!pane) {
    const subPane = document.querySelector('.edit-unit-form .tab-content ' + anchor)
    if (subPane) {
      const parentPane = subPane.closest('.tab-content').parentElement
      if (parentPane && parentPane.id) {
        const parentAnchor = '#' + parentPane.id
        const parentPaneTop = document.querySelector('.edit-unit-form > .tab-content > ' + parentAnchor)
        const parentTrigger = document.querySelector('a[data-bs-target="' + parentAnchor + '"]')
        parentPaneTop && parentPaneTop.classList.add('active', 'show')
        parentTrigger && parentTrigger.classList.add('active')
      }
      pane = subPane
      triggerElement = document.querySelector('button[data-bs-target="' + anchor + '"]')
    }
  }
  pane && pane.classList.add('active', 'show')
  triggerElement && triggerElement.classList.add('active')
}

window['units#edit_addresses'] = function () {
  $('#addresses .nested-fields').each(function () {
    Geocomplete.initSelect({
      input: $(this).find('#gmaps-input-address'),
      details: $(this).find('.details')
    })
  })

  $('#addresses').on('cocoon:after-insert', function (e, element) {
    Geocomplete.initSelect({
      input: element.find('#gmaps-input-address'),
      details: element.find('.details')
    })

    Forms.initCheckbox()
    InitMainAddressCheckboxes()
  })

  InitMainAddressCheckboxes()
}

window['units#index'] = function () {
  $('#clear_search_units_input').on('click', function () {
    $('#search_unit_name').val('')
    $.get('/units')
  })

  $('#search_unit_name').on('keyup', function () {
    let searchTerm = $(this).val()
    if (searchTerm.length < 2) { searchTerm = '' }

    $.get(`/units?search_unit_name=${searchTerm}`)
  })
}
